module.exports = __webpack_public_path__ + "static/media/Misto.92c07322.woff2";